<template>
  <div class="progress w-100 rounded-0 thin-progress mt-0 mb-0">
    <div class="progress-bar" :style="{width: `${percentage}%`}" />
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .thin-progress {
    height: 8px;
  }
</style>
